/*
 * The Okendo star rating lives inside the main product section, which
 * product-ajax-navigation.js morphs on every product swap — re-run
 * Okendo on the fresh markup so it renders for the new product.
 */
document.addEventListener("product:ajax-rendered", (event) => {
  const api = window.okeWidgetApi;
  const section = event.detail?.section;
  if (!api?.initWidget || !section) return;

  section.querySelectorAll("[data-oke-star-rating]").forEach((element) => {
    api.initWidget(element, true);
  });
});

/*
 * Clicking the star rating scrolls to the reviews section.
 *
 * Handled in script rather than by following the #product-reviews
 * hash: a hash change fires popstate, which product-ajax-navigation.js
 * treats as a product navigation (re-render + scroll reset), making the
 * page jump. Capture phase so Okendo's own click-to-scroll on the
 * rating never runs alongside this one.
 */
document.addEventListener(
  "click",
  (event) => {
    const link = event.target.closest("[data-product-reviews-link]");
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    const target = document.getElementById("product-reviews");
    if (!target) return;

    const rootStyle = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyle.getPropertyValue("--header-height")) || 0;
    const promoBarHeight = parseFloat(rootStyle.getPropertyValue("--promo-bar-height")) || 0;

    window.scrollTo({
      top: Math.max(
        target.getBoundingClientRect().top + window.scrollY - headerHeight - promoBarHeight,
        0,
      ),
      behavior: "smooth",
    });
  },
  true,
);
